import assets from 'assets'
import { useAssets } from 'assets/useIcons'
import FreeTag from 'container/components/FreeTag/FreeTag'
import Promps from 'container/components/Promps/Promps'
import UpgradeButton from 'container/components/UpgradeButton/UpgradeButton'
import React, { useContext, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import ApplicationDropdown from '../MiniSidebar/NewSidebar/Components/ApplicationDropdown/ApplicationDropdown'
import { modes } from 'app.config'
import FileUpload from 'container/Dialogs/FileUpload/FileUpload'
import { EditorContext } from 'container/context/editorContext'
import ConfirmationModel from 'container/Dialogs/ConfirmationModel/ConfirmationModel'
import { saveDocument } from 'container/api'

const Topbar = () => {
    const dispatch = useDispatch()
    const newAssets = useAssets();
    const [fetchFile, setFetchFile] = useState(false)
    const editor = useContext(EditorContext);
    const [shouldSaveDoc, setShouldSaveDoc] = useState(false);
    const { bittensor, isSidebar } = useSelector(state => state.utils)
    const loading = useSelector(state => state.chat.responseLoading);
    const selectedconversation = useSelector(state => state.chat.selectedConversation)
    const imageLoading = useSelector(state => state.imageGeneration.loading);
    const isDark = useSelector(state => state.utils.isDarkMode);
    const mode = useSelector(state => state.utils.mode);
    const selectedDoc = useSelector(state => state.documents.selected);
    const user = useSelector(state => state.auth.user);
    const [docLoading, setDocLoading] = useState(false);
    
    
    const handleSidebar = () => {
        // dispatch.utils.setIsDarkMode(!isDark)
        dispatch.utils.setIsSidebar(!isSidebar)
    }

    const handleClick = () => {
        if (!loading && !imageLoading) {
            if (mode === modes.document) {
                if (!selectedDoc && editor.getText().length) {
                    setShouldSaveDoc(true);
                } else {
                    handleSaveDocument();
                    dispatch.outliner.reset();
                    dispatch.documents.setSelected(null);
                    editor.commands.setContent('');
                    editor.chain().focus().run();
                    setShouldSaveDoc(false);

                }
            } else {
                dispatch.chat.setSelectedConversation(null);
                dispatch.chat.setSelectedImage(null)
                dispatch.chat.setMessages([]);
                dispatch.chat.setMobileScreen('chat');
                dispatch.imageGeneration.setSelectedFilter('');
                dispatch.imageGeneration.setSelectedImage('');
                dispatch.imageGeneration.setSelectedTemplate('');
                dispatch.imageGeneration.setCustomPrompt('');
            }
        }
    };

    const handleSaveDocument = async (title) => {
        try {
            setDocLoading(true);
            if (!selectedDoc && editor.getText().length) {
                const data = {
                    user: user.id,
                    title: title || 'Untitled',
                    body: editor.getHTML(),
                };

                await saveDocument(data);
                dispatch.outliner.reset();
                dispatch.documents.setSelected(selectedconversation);
                editor.commands.setContent('');
                editor.chain().focus().run();
                dispatch.documents.getDocuments();
            } else {
                dispatch.documents.updateDocument({
                    body: editor.getHTML(),
                    showToast: false,
                });
            }
        } catch (err) {
            console.log(err.message);
        } finally {
            setDocLoading(false);
        }
    };

    const handleClose = () => {
        dispatch.outliner.reset();
        dispatch.documents.setSelected(null);
        editor.commands.setContent('');
        editor.chain().focus().run();
        setShouldSaveDoc(false);
    };
    

  return (
      <Container isDark={isDark}>
          <div className='title flex align-items-center'>
              <img className='cursor-pointer' onClick={() => window.open('https://chatai.com', '_blank')} src={newAssets.logo} alt='' />
              <VerticleLine />
              <div className='flex justify-content-between new-icons'>
                  <img
                      className='cursor-pointer'
                      onClick={handleSidebar}
                      src={newAssets.sidebar}
                      alt=''
                  />
                  <img
                      className='cursor-pointer'
                      src={newAssets.plus}
                      alt=''
                      onClick={() => {
                          if (mode === modes.chat || mode === modes.image) handleClick()
                          else if (mode === modes.document) setFetchFile(true);
                      }}
                  />
              </div>
              <VerticleLine />
              <div className='w-100 application-dropdown'>
                  <ApplicationDropdown isMobile={false} isIcon={false} />
              </div>
          </div>

          <div className='flex justify-content-end'>
              <div className='searchbox'>
                  {/* <img src={assets.searchIcon} width={12} height={12} alt='' /> */}
                  <assets.searchIcons className='search-icons' />
                  <input placeholder='Search' />
                  <assets.Slash className='slash' />
                  {/* <img src={assets.searchLine} alt='' width={20} height={20} /> */}
              </div>
          </div>
          
          {
              !bittensor && (<div className='right'>

                  <Promps />
                  <FreeTag />

                  <UpgradeButton />

              </div>)
          }

          {fetchFile && <FileUpload open={fetchFile} setOpen={setFetchFile} />}

          {shouldSaveDoc && (
              <ConfirmationModel
                  open={shouldSaveDoc}
                  setOpen={handleClose}
                  action={handleSaveDocument}
                  descripiton="If you don't save your document your changes will be lost."
                  title='Save document'
                  btnText='Save'
                  loading={docLoading}
              />
          )}
    </Container>
  )
}

export default Topbar

const Container = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 5px;
    background-color: ${({ isDark }) => isDark ? 'var(--new-dark-color)' : 'var(--new-light-color)'};

    border-bottom: 1px solid ${({ isDark }) => isDark ? 'var(--new-dark-color-border)' : 'var(--new-light-color-border)'};
    & .new-icons{
        min-width: 60px;
    }

    & .title{
        padding-left: 20px;
        gap: 16px;
    }

    & .application-dropdown{
        .main-app-dropdown{
            background-color: transparent !important;
        }
        & .name{
            color:${({ isDark }) => isDark ? '#FFFFFF' : 'var(--new-dark-color)'} !important;
            font-size: 16px !important;
            font-weight: 500 !important;
            line-height: 24px !important;
            
        }

        & .dropdown-value{
            border-bottom: none !important;
            min-width: 128px !important;
            padding: 0px !important;
        }
    }

    & .searchbox {
        
        border-radius: 8px;
        border: 1px solid ${({ isDark }) => isDark ? 'var(--new-dark-color)' : 'rgba(230, 230, 230, 1)'};
        display: flex;
        align-items: center;
        justify-content: flex-end;
        height: 36px;
        /* width: 100%; */
        width: 487px;
        gap: 5px;
        padding: 5px 5px 5px 10px;

        & .slash path{
            fill: ${({ isDark }) => isDark ? 'var(--new-dark-color)' : 'rgba(217, 218, 224, 1)'};
        }

        & .search-icons path {
            stroke: ${({ isDark }) => isDark ? 'var(--new-dark-color) ' : 'rgba(217, 218, 224, 1)'} ;
        }

        & input {
            background-color: transparent;
            outline: none;
            border: none;
            font-weight: 300;
            font-size: 14px;
            width: 100%;
            color: ${({ isDark }) => isDark ? 'var(--new-dark-color)' : 'rgba(217, 218, 224, 1)'};
            ::placeholder {
                color: ${({ isDark }) => isDark ? 'var(--new-dark-color)' : 'rgba(217, 218, 224, 1)'};
                opacity: 1; 
            }
        }

        
    }

    & .right {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 12px;
        padding: 0px;
        margin: 0px;
    }

    @media only screen and (max-width: 1000px) {
        display: none;
    }
`

const VerticleLine = styled.div`
    width: 1px;
    height: 14px;
    border: 1px solid #4D4F56;
`